import sys from "../sys"
import roleList from "../items/role_list"
import employeeList from "../items/employee_list"
import logList from "../items/log_list"
import shopList from "../items/shop_list"
import shopEmployeeList from "../items/shop_employee_list"
import config from "../items/config"
import appUserList from "../items/app_user_list"
import performanceConfigList from "../items/performance_config_list"
import courseList from "../../edu/items/course_list.vue"
import classroomList from "../../edu/items/classroom_list"
import stopDateList from "../items/stop_date_list"

export default {
	path:'sys',
	name:'sys',
	component:sys,
	children:[
		{
			path:'role/list',
			name:'role-list',
			component:roleList
		},
		{
			path:'employee/list',
			name:'employee-list',
			component:employeeList
		},
		{
			path:'log/list',
			name:'log-list',
			component:logList
		},
		{
			path:'shop/list',
			name:'shop-list',
			component:shopList
		},
		{
			path:'shop/employee/list',
			name:'shop-employee-list',
			component:shopEmployeeList
		},
		{
			path:'config',
			name:'config-page',
			component:config
		},
		{
			path:'app/user/list',
			name:'app-user-page',
			component:appUserList
		},
		{
			path:'performance/config/list',
			name:'performance-config-list',
			component:performanceConfigList
		},
		{
			path:'course/list',
			name:'course-list',
			component:courseList
		},
		{
			path:'classroom/list',
			name:'classroom-list',
			component:classroomList
		},
		{
			path:'stop/date/list',
			name:'stop-date-list',
			component:stopDateList
		},
		
	]
}